var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-center",attrs:{"outlined":"","color":"transparent"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.spinner)}}),_c('v-card-text',{staticClass:"text-italic"},[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }